/*
 * @Description: '关于我们'页面所有请求
 * @Author: 任录
 * @Date: 2019-07-22 15:13:52
 * @LastEditTime: 2019-07-22 17:37:49
 */

import * as http from './base'

/**
 * 获取目录结构 
 */
const getMenu = () => {
	return http.get('/os/menu')
}

/**
 * 获取目录结构 
 */
const getAllColumns = () => {
	return http.get('/os/columns')
}

/**
 * 获取并增加浏览量 
 */
const getPv = () => {
	return http.get('/os/pv')
}

/**
 * 获取验证码
 */
const getCode = () => {
	return http.get("/os/code")
}

const getLinks = () => {
	return http.get("/os/links")
}

const getBanners = () => {
	return http.get("/os/banners")
}

const getColumnLinks = () => {
	return http.get("/os/columnLinks")
}

const getTheme = () => {
	return http.get("/os/theme")
}

const getHoverRouters = () => {
	return http.get("/os/hoverRouter")
}


export default {
	getMenu,
	getPv,
	getAllColumns,
	getCode,
	getLinks,
	getBanners,
	getColumnLinks,
	getTheme,
	getHoverRouters
}



// WEBPACK FOOTER //
// ./src/http/common.js